import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { I18nService } from '@app/core/i18n.service';
import { RouterModule, Routes } from '@angular/router';
import { extract } from '@app/core';
import { FormTemplateComponent } from '@app/shared/form/form-template.component';
import { FormInputComponent } from '@app/shared/form/inputs/form-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormTextareaComponent } from '@app/shared/form/inputs/form-textarea.component';
import { FormSelectComponent } from '@app/shared/form/inputs/form-select.component';
import { SelectSearchPipe } from '@app/shared/form/inputs/select-search.pipe';
import { FormCheckboxComponent } from '@app/shared/form/inputs/form-checkbox.component';
import { FormRadioComponent } from '@app/shared/form/inputs/form-radio.component';
import { FormSwitchComponent } from '@app/shared/form/inputs/form-switch.component';
import { FormButtonComponent } from '@app/shared/form/buttons/form-button.component';
import { FormFileComponent } from '@app/shared/form/inputs/form-file.component';
import { FormDropdownComponent } from '@app/shared/form/inputs/form-dropdown.component';

const routes: Routes = [
  {
    path: 'form-template',
    component: FormTemplateComponent,
    data: {
      title: extract('Form templates'),
    },
  },
];

@NgModule({
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, RouterModule.forChild(routes)],
  declarations: [
    FormTemplateComponent,
    FormInputComponent,
    FormTextareaComponent,
    FormSelectComponent,
    SelectSearchPipe,
    FormCheckboxComponent,
    FormRadioComponent,
    FormSwitchComponent,
    FormButtonComponent,
    FormFileComponent,
    FormDropdownComponent,
  ],
  exports: [
    FormTemplateComponent,
    FormInputComponent,
    FormTextareaComponent,
    FormSelectComponent,
    SelectSearchPipe,
    FormCheckboxComponent,
    FormRadioComponent,
    FormSwitchComponent,
    FormButtonComponent,
    FormFileComponent,
    FormDropdownComponent,
  ],
  providers: [I18nService],
})
export class FormModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/form.module.ts